import { render, staticRenderFns } from "./Anais.vue?vue&type=template&id=49d71ab2&scoped=true&"
import script from "./Anais.vue?vue&type=script&lang=ts&"
export * from "./Anais.vue?vue&type=script&lang=ts&"
import style0 from "./Anais.vue?vue&type=style&index=0&id=49d71ab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d71ab2",
  null
  
)

export default component.exports